import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { brandsQuery, meQuery } from '../lib/queries.js';

// Layout route for the brief wizard.
//
// /brand/$slug/brief itself is the identity step (rendered by
// brand.$slug.brief.index.tsx). /brand/$slug/brief/voice and
// /brand/$slug/brief/customer are the next steps. Without this
// layout file the children would have nowhere to render — TanStack
// matches them as nested under /brief, and the parent must provide
// an <Outlet/> for child content to show.
//
// brand-resolution + auth happens at every level (children re-check)
// so this layout only does the bare minimum: confirm the slug
// exists, then render the matched child via Outlet.

export const Route = createFileRoute('/brand/$slug/brief')({
  beforeLoad: async ({ params, context: { queryClient } }) => {
    const me = await queryClient.ensureQueryData(meQuery());
    if (!me) throw redirect({ to: '/login' });
    const brands = await queryClient.ensureQueryData(brandsQuery());
    const brand = brands.find((b) => b.slug === params.slug);
    if (!brand) throw redirect({ to: '/brands' });
    return { me, brand };
  },
  component: () => <Outlet />,
});
